import camelize from 'lodash.camelcase';
import * as React from 'react';

import UIAsset from 'components/atoms/UIAsset';
import { EventLevelsValues } from 'defs/events';
import { NumericalEventLevels } from 'defs/events';
import i18n, { labelExists } from 'helper/i18n';
import { DateTimeType } from 'types/DateTime';

export type AwardProps = {
	attributes?: any;
	code: string;
	eventLevel: EventLevelsValues;
	modifier?: string;
	awardedDateTime?: DateTimeType | null;
};

const getName = (code: string, eventLevel: string): string => {
	return `${code}${eventLevel && NumericalEventLevels[eventLevel] ? `-${NumericalEventLevels[eventLevel]}` : '-0'}`;
};

export const getAwardLabel = (type: string = 'badge', field: string, award?: AwardProps): string => {
	const label = award
		? `react.impulsCoach.events.${type}.${camelize(award.code)}.${camelize(award.eventLevel)}.${camelize(field)}`
		: '';

	if (!labelExists(label)) {
		return i18n('react.impulsCoach.components.award.generalFallbackLabel');
	}

	return i18n(label);
};

/*
 * Returns either an Award or an Award placeholder.
 *
 * The signature is kind of ugly, but with parameter destructuring *and* default
 * values flow will complain. And as you know, if it works it's not stupid. ;)
 *
 * @param {AwardProps} props
 * @returns {Element}
 */
export const Award = ({ code, modifier, eventLevel }: AwardProps) => {
	const name = getName(code, eventLevel);

	return (
		<div className={`a-award${modifier ? ` a-award--${modifier}` : ''}`}>
			{name ? <UIAsset className="a-award__image" src={`img/svg/award/${name}.svg`} alt={`${name}`} /> : null}
		</div>
	);
};

Award.displayName = 'Award';

export default Award;
